import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ObjectTypePipeModule } from '../pipes/object-type/object-type.module';
import { TranslatePipe } from '../pipes/translate/translate.pipe';
import { MitsBadgeModule } from '../mits-badge/mits-badge.module';
import { MitsButtonsPopoverModule } from '../mits-buttons-popover/mits-buttons-popover.module';
import { MitsFilterButtonModule } from '../mits-filter-button/mits-filter-button.module';
import { MitsIconModule } from '../mits-icon/mits-icon.module';
import { MitsTableHelper } from './helpers/mits-table-helper';
import { PaginateHelper } from './helpers/paginate-helper';
import { MitsTableComponent } from './mits-table.component';
import { DestroyFilterPipe } from './pipes/destroy-filter';
import { FormatArrayPipe } from './pipes/format-array';
import { GetValuePipe } from './pipes/get-value';
import { GroupByPipe } from './pipes/group-by';
import { SearchFilterPipe } from './pipes/search-filter';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    MitsIconModule,
    MitsButtonsPopoverModule,
    MitsFilterButtonModule,
    MitsBadgeModule,
    ObjectTypePipeModule,
    ReactiveFormsModule,
    TranslatePipe,
],
  declarations: [
    MitsTableComponent,
    SearchFilterPipe,
    GetValuePipe,
    FormatArrayPipe,
    DestroyFilterPipe,
    GroupByPipe,
  ],
  entryComponents: [MitsTableComponent],
  exports: [
    MitsTableComponent,
    SearchFilterPipe,
    GetValuePipe,
    FormatArrayPipe,
    DestroyFilterPipe,
    GroupByPipe,
  ],
  providers: [
    MitsTableHelper,
    PaginateHelper,
    TranslatePipe,
    SearchFilterPipe,
    GetValuePipe,
    FormatArrayPipe,
    DestroyFilterPipe,
    GroupByPipe,
  ],
})
export class MitsTableModule {}
